import React from 'react';
import { GdrpContext } from './GdprContext';
import classnames from 'classnames';

type Props = {
    className?: Array<string> | string;
}

export default function GdprDialogButton (props: Props) {

    const {dispatch } = React.useContext(GdrpContext);
    const className = (props.className && Array.isArray(props.className)) ? props.className : [props.className];

    const openDialog = (e) => {
        e.preventDefault();

        dispatch({type: "SHOW_SETTINGS"});
    }

    return <a href="#" onClick={openDialog} className={classnames(className)}>Privatsphähre Einstellungen</a>
}